<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.mc_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{form.main.ma_prodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单单号</label>
            <span class="weui-form-preview__value">{{form.main.ma_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品型号</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已完工数</label>
            <span class="weui-form-preview__value">{{form.main.ma_madeqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{form.main.ma_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单号</label>
            <span class="weui-form-preview__value">{{form.main.ma_salecode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.ma_delivery}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原数量</label>
            <span class="weui-form-preview__value">{{form.main.mc_qty_old}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新数量</label>
            <span class="weui-form-preview__value">{{form.main.mc_qty_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind != '委外'">
            <label class="weui-form-preview__label">原开工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.mc_planbegindate_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind != '委外'">
            <label class="weui-form-preview__label">新开工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.mc_planbegindate_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind != '委外'">
            <label class="weui-form-preview__label">原完工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.mc_planenddate_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind != '委外'">
            <label class="weui-form-preview__label">新完工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.mc_planenddate_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原加工单价</label>
            <span class="weui-form-preview__value" >{{form.main.mc_price_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新加工单价</label>
            <span class="weui-form-preview__value" >{{form.main.mc_price_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原外协厂商</label>
            <span class="weui-form-preview__value" >{{form.main.mc_vendname_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新外协厂商</label>
            <span class="weui-form-preview__value" >{{form.main.mc_vendname_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原联系人</label>
            <span class="weui-form-preview__value" >{{form.main.mc_contact_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新联系人</label>
            <span class="weui-form-preview__value" >{{form.main.mc_contact_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原交货地址</label>
            <span class="weui-form-preview__value" >{{form.main.mc_shipaddresscode_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新交货地址</label>
            <span class="weui-form-preview__value" >{{form.main.mc_shipaddresscode_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原联系电话</label>
            <span class="weui-form-preview__value" >{{form.main.mc_tel_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新联系电话</label>
            <span class="weui-form-preview__value" >{{form.main.mc_tel_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原付款方式</label>
            <span class="weui-form-preview__value" >{{form.main.mc_payments_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新付款方式</label>
            <span class="weui-form-preview__value" >{{form.main.mc_payments_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原币种</label>
            <span class="weui-form-preview__value" >{{form.main.mc_currency_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新币种</label>
            <span class="weui-form-preview__value" >{{form.main.mc_currency_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">原税率</label>
            <span class="weui-form-preview__value" >{{form.main.mc_taxrate_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ma_kind == '委外'">
            <label class="weui-form-preview__label">新税率</label>
            <span class="weui-form-preview__value">{{form.main.mc_taxrate_new}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.mc_auditman}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{form.main.mc_reason}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/make/change"
    };
  }
};
</script>